export type ChainNames = 'Aptos'; /*|'HypeEvm';*/

export type NetworkConfig = {
	label: string;
	image: string;
	isTestChain: boolean;
	chainId: number;
	chainName: string;
	path: string;
	name: ChainNames;
	nativeCurrency: {
		name: string;
		symbol: string;
		decimals: number;
	};
	rpcUrls: string[];
	disabled?: boolean;
	comingSoon?: boolean;
};

export const networkConfig: Record<ChainNames, any> = {
	Aptos: {
		label: 'Aptos',
		name: 'Aptos',
		image: '/images/aptos.png',
		isTestChain: false,
		path: 'aalanche',
		chainId: 42161,
		chainName: 'Aptos Mainnet',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18,
		},
		rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
		blockExplorerUrls: ['https://cchain.explorer.avax.network/'],
		disabled: false,
	} /*Arbitrum: {
		label: 'Arbitrum',
		name: 'Arbitrum',
		image: '/images/arbitrum.svg',
		isTestChain: false,
		path: 'aalanche',
		chainId: 42161,
		chainName: 'Avalanche Mainnet',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18,
		},
		rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
		blockExplorerUrls: ['https://cchain.explorer.avax.network/'],
		disabled: false,
	},*/,
	/*HypeEvm: {
		label: 'HypeEvm',
		name: 'HypeEvm',
		image: '/images/hyper.png',
		isTestChain: false,
		path: 'hyper',
		chainId: 999,
		chainName: 'HypeEvm',
		nativeCurrency: {
			name: 'HYPE',
			symbol: 'HYPE',
			decimals: 18,
		},
		rpcUrls: ['https://rpc.hyperliquid.xyz/evm'],
		blockExplorerUrls: ['https://purrsec.com'],
		disabled: false,
	},*/
};
